export default __webpack_public_path__ + "static/header-logo-2f93c28c4f43c9d23da676d9a49d673d.svg";